export default "__VITE_ASSET__DBwsA09l__"